import { MyChannel } from "@/services/apiService/api.types";
import { BuffetCategories, Categories } from "@/helpers/constants";

export enum BuffetFilterType {
  DateFilter = "DateFilter",
  CategoryFilter = "CategoryFilter"
}

export const defaultChannel: MyChannel = {
  active: 0,
  id: 0,
  name: "",
  default_position: 0,
  channel_type_id: 1,
  epg_url: "",
  product_id: 0,
  is_product: 0,
  stream_name: "",
  mcast_live: "",
  default_lock: 0,
  media: {
    id: 0,
    name: ".jpg",
    type: "",
    size: 0,
    created_at: 0,
    updated_at: 0,
    title: "",
    url: "",
    thumb: ""
  },
  parentalLock: false,
  isFavorite: false,
  type: { id: 1, name: "TV" },
  canWatch: true,
  timesWatched: "",
  catchup: 0,
  categories: [
    { id: 0, name: Categories.Movies, channelsCount: 0, vodsCount: 0 }
  ],
  videoLive: "",
  userOrder: 0
};

export const enum BuffetAction {}

export const enum BuffetMutation {
  setUpdatedBuffetItems = "setUpdatedBuffetItems",
  setPlayedEpgItemPos = "setPlayedEpgItemPos",
  setPlayedEpgItemId = "setPlayedEpgItemId",
  setPlayedEpgItemCat = "setPlayedEpgItemCat",
  setPlayedEpgItemDate = "setPlayedEpgItemDate"
}

export const enum BuffetGetter {
  getUpdatedBuffetItems = "getUpdatedBuffetItems",
  getPlayedEpgItemPos = "getPlayedEpgItemPos",
  getPlayedEpgItemId = "getPlayedEpgItemId",
  getPlayedEpgItemCat = "getPlayedEpgItemCat",
  getPlayedEpgItemDate = "getPlayedEpgItemDate"
}
export interface BuffetState {
  updatedBuffetItems: boolean;
  playedEpgItemPos?: PlayedEpgItemCoordinates;
  playedEpgItemId?: number;
  playedEpgItemCat?: BuffetCategories;
  playedEpgItemDate?: string;
}

export interface PlayedEpgItemCoordinates {
  swiperIndex: number;
  slideIndex: number;
}
